<template>
  <div class="memberPie" ref="echarts"></div>
</template>

<script>
import { EchatsMixin } from '@/utils/echarts';
export default {
  mixins: [EchatsMixin],
  name: 'barAndLine',
  data() {
    return {};
  },
  props: ['toilet', 'axisX'],
  computed: {},
  watch: {
    toilet: {
      handler(n) {
        if (n) {
          this.echarts_satisfied(n);
        }
      },
      deep: true
    }
  },
  methods: {
    // 满意度echarts
    echarts_satisfied(data) {
      let name = [],
        water = [],
        electric = [],
        peoNum = [];
      for (let i = 0; i < data.length; i++) {
        name.push(data[i][this.axisX]);
        water.push(data[i].water);
        peoNum.push(data[i].peoNum);
        electric.push(data[i].electric);
      }
      let colors = ['#5470C6', '#91CC75', '#EE6666'];
      let myChart = this.resizeEcharts();
      let option = {
        color: colors,

        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          top: 30,
          right: 10,
          left: 10,
          y: 0,
          y2: 0,
          containLabel: true,
        },
        legend: {
          data: ['水量', '电量', '人流量'],
          textStyle: {
            color: "#61d2f7",
          },
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#61d2f7",  //更改坐标轴文字颜色
              }
            },
            data: name,
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '水量',
            position: 'right',
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0]
              }
            },
            axisLabel: {
              formatter: '{value} t'
            }
          },
          {
            type: 'value',
            name: '电量',
            position: 'right',
            offset: 40,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1]
              }
            },
            axisLabel: {
              formatter: '{value} kw'
            }
          },
          {
            type: 'value',
            name: '人流量',
            position: 'left',
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[2]
              }
            },
            axisLabel: {
              formatter: '{value} 人'
            }
          }
        ],
        series: [
          {
            name: '水量',
            type: 'line',
            smooth: true,
            data: water
          },
          {
            name: '电量',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: electric
          },
          {
            name: '人流量',
            type: 'line',
            smooth: true,
            yAxisIndex: 2,
            data: peoNum
          }
        ]
      };
      this.autoMatic(myChart, option.series[0].data.length);
      myChart.clear();
      myChart.setOption(option, true);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.memberPie {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/html/barAndLine.vue